import {TASK_VIEW_GRID_CONFIG} from "../../../constants/TaskViewGridConfig.js";
import {RESOURCE_VIEW_CONFIG} from "../../../constants/PlanView/ViewConfg.jsx";
import {CLIENTS_GRID_CONFIG} from "../../../constants/ClientViewGridConfig.js";
import {REMINDERS_GRID_CONFIG} from "../../../constants/ReminderViewGridConfig.js";
import {ScheduleUserConfig} from "../../../constants/ScheduleUserConfig.jsx";
import {CONTACTS_GRID_CONFIG} from "../../../constants/ContactViewGridConfig.jsx";
import {VIEW_TYPES} from "../../../constants/OtherKeys.jsx";
import {TASK_BUDGET_GRID_CONFIG} from "../../../constants/TaskBudgetGridConfig.jsx";
import { REMINDER_VIEW_COLUMN } from "../../../constants/ReminderViewColumns.jsx";
import { INCENTIVE_POINTS_GRID_CONFIG } from "../../../constants/IncentivePointsGridConfig.jsx";

// reason of defining this constant in different file other than OtherKey or utils is that we get cross-dependency error "Cannot access 'Name' before initialization"
export const STATE_ID_TO_VIEW_NAME = {
  [`${VIEW_TYPES.tasks}-${VIEW_TYPES.tasks}`]: {
    title: "Task",
    config: TASK_VIEW_GRID_CONFIG,
  },
  [`${VIEW_TYPES.resources}-${VIEW_TYPES.resources}`]: {
    title: "Resource",
    config: RESOURCE_VIEW_CONFIG,
  },
  [`${VIEW_TYPES.clients}-${VIEW_TYPES.clients}`]: {
    title: "Client",
    config: CLIENTS_GRID_CONFIG,
  },
  [`${VIEW_TYPES.planView}-${VIEW_TYPES.resources}`]: {
    title: "Plan Resource",
    config: RESOURCE_VIEW_CONFIG,
  },
  [`${VIEW_TYPES.planView}-${VIEW_TYPES.tasks}`]: {
    title: "Plan Task",
    config: TASK_VIEW_GRID_CONFIG,
  },
  [`${VIEW_TYPES.schedulerView}-${VIEW_TYPES.resources}`]: {
    title: "Schedule Resource",
    config: RESOURCE_VIEW_CONFIG,
  },
  [`${VIEW_TYPES.schedulerView}-${VIEW_TYPES.tasks}`]: {
    title: "Schedule Task",
    config: TASK_VIEW_GRID_CONFIG,
  },
  [`${VIEW_TYPES.users}-${VIEW_TYPES.users}`]: {
    title: "User",
    config: ScheduleUserConfig,
  },
  [`${VIEW_TYPES.notify}-${VIEW_TYPES.notify}`]: {
    title: "Notify",
    config: REMINDERS_GRID_CONFIG,
  },
  [`${VIEW_TYPES.reminder}-${VIEW_TYPES.reminder}`]: {
    title: "Reminder",
    config: { ...REMINDERS_GRID_CONFIG, columns: REMINDER_VIEW_COLUMN},
  },
  [`${VIEW_TYPES.contacts}-${VIEW_TYPES.contacts}`]: {
    title: "Contact",
    config: CONTACTS_GRID_CONFIG,
  },
  [`${VIEW_TYPES.taskBudget}-${VIEW_TYPES.taskBudget}`]: {
    title: "Task Budget",
    config: TASK_BUDGET_GRID_CONFIG
  },
  [`${VIEW_TYPES.incentivePoints}-${VIEW_TYPES.incentivePoints}`]: {
    title: "Points",
    config: INCENTIVE_POINTS_GRID_CONFIG
  }
}
